import {
  UserLevelLabels,
  UserLevelOrder,
  type UserLevelType,
} from "@redotech/account-common/job-level";
import { RedoOptionCard } from "@redotech/redo-web/arbiter-components/option-card/redo-option-card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { USER_JOB_GROUPS } from "./job-groups";

export interface JobLevelSelectorProps {
  jobGroupKeys: ReadonlySet<string>;
  onToggleJobGroup: (key: string) => void;
  level: UserLevelType | null;
  onLevelChange: (level: UserLevelType | null) => void;
  /**
   * When true, the level section is always visible. Defaults to false, which
   * reveals it only after a job group is selected (the welcome-flow behavior).
   */
  alwaysShowLevel?: boolean;
}

export const JobLevelSelector = memo(function JobLevelSelector({
  jobGroupKeys,
  onToggleJobGroup,
  level,
  onLevelChange,
  alwaysShowLevel = false,
}: JobLevelSelectorProps) {
  return (
    <Flex dir="column" gap="none" w="full">
      <Flex gap="md" w="full" wrap="wrap">
        {USER_JOB_GROUPS.map((group, index) => (
          <RedoOptionCard
            animateReveal
            Icon={group.Icon}
            key={group.key}
            label={group.label}
            layout="grid"
            onClick={() => onToggleJobGroup(group.key)}
            revealIndex={index}
            selected={jobGroupKeys.has(group.key)}
          />
        ))}
      </Flex>
      {(alwaysShowLevel || jobGroupKeys.size > 0) && (
        <Flex dir="column" gap="md" mt="4xl">
          <Text fontSize="sm" fontWeight="medium">
            What's your level?
          </Text>
          <Flex gap="md" w="full" wrap="wrap">
            {UserLevelOrder.map((value, index) => (
              <RedoOptionCard
                animateReveal
                key={value}
                label={UserLevelLabels[value]}
                layout="grid"
                onClick={() => onLevelChange(level === value ? null : value)}
                revealIndex={index}
                selected={level === value}
              />
            ))}
          </Flex>
        </Flex>
      )}
    </Flex>
  );
});
